import { NgModule } from '@angular/core';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ScrollTopModule } from 'primeng/scrolltop';
import { AppSharedModule } from '../app-shared.module';
import { CompetenciaLocalModule } from '../competencia-local/competencia-local.module';
import { ComponentsModule } from '../components/components.module';
import { FonteDadosMonitoramentoService } from '../fonte-dados-monitoramento/fonte-dados-monitoramento.service';
import { MonitoramentoModule } from '../monitoramento/monitoramento.module';
import { OrgaoJulgadorColegiadoLocalModule } from '../orgao-julgador-colegiado-local/orgao-julgador-colegiado-local.module';
import { TipoParteLocalModule } from '../tipo-parte-local/tipo-parte-local.module';
import { TipoProcessoDocumentoLocalModule } from '../tipo-processo-documento-local/tipo-proc-doc-loc.module';
import { OrgaoJulgadorLocalModule } from './../orgao-julgador-local/orgao-julgador-local.module';
import { FonteDadosEdicaoComponent } from './fonte-dados-edicao/fonte-dados-edicao.component';
import { FonteDadosFrmComponent } from './fonte-dados-frm/fonte-dados-frm.component';
import { FonteDadosInfraestruturaComponent } from './fonte-dados-infraestrutura/fonte-dados-infraestrutura.component';
import { FonteDadosListaComponent } from './fonte-dados-lista/fonte-dados-lista.component';
import { FonteDadosMonitorComponent } from './fonte-dados-monitor/fonte-dados-monitor.component';
import { FonteDadosProxyComponent } from './fonte-dados-proxy/fonte-dados-proxy.component';
import { FonteDadosVisualizadorDeParaComponent } from './fonte-dados-visualizador-de-para/fonte-dados-visualizador-de-para.component';
import { FonteDadosVisualizadorPessoaProcessamentoComponent } from './fonte-dados-visualizador-pessoa-processamento/fonte-dados-visualizador-pessoa-processamento.component';
import { FonteDadosVisualizadorProcessoDocumentoProcessamentoComponent } from './fonte-dados-visualizador-processo-documento-processamento/fonte-dados-visualizador-processo-documento-processamento.component';
import { FonteDadosVisualizadorProcessoProcessamentoComponent } from './fonte-dados-visualizador-processo-processamento/fonte-dados-visualizador-processo-processamento.component';
import { FonteDadosBandoDeDadosComponent } from './fonte-dados-banco-de-dados/fonte-dados-banco-de-dados.component';
import { FonteDadosRoutingModule } from './fonte-dados.routing';
import { FonteDadosService } from './fonte-dados.service';
import { FonteDadosMensagemErroService } from './fonte-dados-mensagem-erro.service';
import { FonteDadosComunicacaoModule } from '../fonte-dados-comunicacao/fonte-dados-comunicacao.module';
import {JurisdicaoLocalModule} from '../jurisdicao-local/jurisdicao-local.module';

@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule,
    MonitoramentoModule,
    OrgaoJulgadorLocalModule,
    CompetenciaLocalModule,
    TipoProcessoDocumentoLocalModule,
    TipoParteLocalModule,
    OrgaoJulgadorColegiadoLocalModule,
    NgxJsonViewerModule,
    ScrollTopModule,
    FonteDadosComunicacaoModule,
    JurisdicaoLocalModule
  ],
  declarations: [
    FonteDadosListaComponent,
    FonteDadosEdicaoComponent,
    FonteDadosFrmComponent,
    FonteDadosVisualizadorPessoaProcessamentoComponent,
    FonteDadosVisualizadorProcessoProcessamentoComponent,
    FonteDadosVisualizadorProcessoDocumentoProcessamentoComponent,
    FonteDadosMonitorComponent,
    FonteDadosVisualizadorDeParaComponent,
    FonteDadosProxyComponent,
    FonteDadosInfraestruturaComponent,
    FonteDadosBandoDeDadosComponent
  ],
  exports: [
    FonteDadosRoutingModule
  ],
  providers: [
    FonteDadosService, FonteDadosMonitoramentoService, FonteDadosMensagemErroService
  ]
})
export class FonteDadosModule { }
